import carousel1 from '../images/IMG_4931.jpg'
import carousel3 from '../images/IMG_4978.jpg'
import carousel4 from '../images/IMG_5042.jpg'


export const carousel = [
    carousel1
    ,carousel3
    ,carousel4
]